import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusDropdown],[dropdown]',
})
export class DropdownDirective {
  @HostBinding('class.ui-notification--dropdown')
  get isDropdownClass() {
    return true;
  }
}
